<template>
  <div class="gp-content">
    <content-nav-bar>
      <h5 class="is-size-4 level-item">Edit Profile</h5>
      <a v-on:click="submit()" class="add button level-item">
        <i class="far fa-save"></i>
        Save
      </a>
      <loader class="level-item" :showLoader="showLoader">Saving Profile</loader>
      <p v-if="message" class="message level-item">{{ message }}</p>
    </content-nav-bar>
    <profile-edit-create :profile.sync="internalProfile" class="profile-form">
    </profile-edit-create>
  </div>
</template>

<script>
import ProfileEditCreate from '@/components/profiles/ProfileEditCreate.vue';
import ContentNavBar from '@/components/ContentNavBar.vue';
import Loader from '@/components/Loader.vue';

export default {
  name: 'ProfileEdit',
  components: {
    ProfileEditCreate,
    ContentNavBar,
    Loader,
  },
  props: {
    profile: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showLoader: false,
      internalProfile: Object.assign({}, this.profile),
      message: null,
    };
  },
  computed: {
    computedProfile() {
      return {
        id: this.profile.id,
        name: this.internalProfile.name,
        description: this.internalProfile.description,
        autoUpdate: this.internalProfile.autoUpdate,
        actionConfigs: this.internalProfile.actionConfigs,
        infoSync: JSON.stringify(this.internalProfile.infoSync),
      };
    },
  },
  async mounted() {
    const actionConfigs = await this.$store.dispatch('primary/listActionConfigs', {
      direction: 'DESC',
      field: 'created',
    });
    this.actionConfigsOptions = actionConfigs.items;
    this.internalProfile.actionConfigs = this.profile.actionConfigs.id;
  },
  methods: {
    async submit() {
      this.showLoader = true;
      const profile = await this.$store.dispatch('primary/updateProfile', this.computedProfile);
      this.showLoader = false;
      if (profile) {
        this.message = 'Profile saved!';
      } else {
        this.message = 'Error saving profile!';
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.profile-form {
  padding: 0 $content-padding;
}

.profile-form, .profile-button {
  margin-top: $content-padding;
}
</style>
